export interface Interval{
    start:number;
    end:number;  // Changed from 'stop' to 'end' for consistency with backend
    fingers: [Array<number>, Array<number>];
    grip: string;
    expectedStrength: number;
}
export class Interval implements Interval{
    constructor(props){
        this.start=props.start;
        // Support both 'end' and 'stop' for backward compatibility
        this.end=props.end !== undefined ? props.end : props.stop;
        this.fingers=props.fingers;
        this.grip= props.grip;
        this.expectedStrength = props.expectedStrength;

    }
}